// iter-140 — Content dataset for the 4 dedicated service pages
// (Excavation, Septic, Site Services, Demolition). Copy lifted
// verbatim from the user's Sep 3 2026 steeltooth.ca screenshots so
// the pages read exactly like the source site.

export const SERVICE_CONTENT = {
    excavation: {
        slug: "excavation",
        title: "Excavation",
        hero: {
            eyebrow: "Premier Excavation and Grading Services in Barrie",
            heading: "Full-Service Excavation Solutions",
            img: "/images/services/excavation.jpg",
        },
        intro: {
            eyebrow: "Expert Excavation in Barrie",
            heading: "Comprehensive Solutions",
            body:
                "At Steeltooth Contracting, we offer a wide range of excavation services tailored to your needs. Our expertise covers residential and commercial footings, foundations, backfill, infills, and more. We also specialize in earthwork services, drainage swales, grading, driveways, retaining walls, entrances, culverts, and final grading. Our lot clearing and grubbing services ensure your property is ready for development. Trust our professional team for all your excavation needs in Barrie.",
        },
        photo: "/images/services/excavation.jpg",
        quality: {
            eyebrow: "Barrie's Grading Specialists",
            heading: "Unmatched Quality and Service",
            body:
                "Steeltooth Contracting stands out as the premier choice for excavation services in Barrie. Our dedicated team of professionals is committed to customer satisfaction, saving you money, and completing the job on time and within budget. With our team's years of experience, we understand the unique challenges of each project and work closely with our clients to ensure a smooth process from start to finish. Choose Steeltooth Contracting for reliable, efficient, and top-quality excavation services in Barrie.",
        },
        offerings: {
            eyebrow: "Excavation Services Simcoe County",
            heading: "All-inclusive Offerings",
            items: [
                "Site preparation and clearing",
                "Foundation excavation",
                "Trenching and grading",
                "Backfilling and compaction",
                "Drainage and erosion control",
            ],
        },
        closingPhoto: "/images/services/excavation.jpg",
        cta: {
            heading: "Start Your Excavation Project Today",
            body:
                "Steeltooth Contracting provides exceptional excavation services in Barrie and the surrounding areas. Our experienced team ensures top-notch results for residential and commercial projects. Don't wait any longer to bring your excavation project to life. Contact Steeltooth Contracting for a personalized consultation and experience the difference our expert team brings to the table.",
        },
    },

    septic: {
        slug: "septic",
        title: "Septic Services",
        hero: {
            eyebrow: "Barrie's Septic System Experts",
            heading: "About Steeltooth Septic Solutions",
            img: "/images/services/septic.jpg",
        },
        intro: {
            eyebrow: "Septic Services You Can Trust",
            heading: "Comprehensive Care",
            body:
                "Steeltooth Contracting specializes in a wide range of septic services, including design, installation, repair, maintenance, and inspection. Our team of skilled professionals ensures that your septic system is properly designed, installed, and maintained to maximize its lifespan and efficiency. We take pride in our commitment to providing the highest quality services and customer satisfaction. With Steeltooth Contracting, you can trust that your septic system is in the hands of industry experts who understand the unique requirements of your property and the local environment.",
        },
        photo: "/images/services/septic.jpg",
        subSection: {
            eyebrow: "Septic System Design",
            heading: "Systems Tailored For You",
            body:
                "Septic systems aren't one-size fits all. That's why Steeltooth Contracting provides comprehensive septic system design services for residential and commercial properties. Our expert team handles everything from soil testing, system design, and site planning to permit application, ensuring a septic solution that's tailored to your needs. We are committed to environmental safety, exceeding building code regulations, and offering Frost Protection for enduring efficiency.",
        },
        quality: {
            eyebrow: "Unmatched Expertise and Reliability",
            heading: "Superior Septic Services Barrie",
            body:
                "Choosing Steeltooth Contracting means selecting a team of professionals with years of experience in septic system services. We are fully licensed, insured, and compliant with local and provincial regulations. Our team is committed to using advanced technology and equipment, ensuring that each project is completed safely and efficiently. By partnering with Steeltooth Contracting, you can rest assured that your septic system will be handled with the utmost care and professionalism.",
        },
        offerings: {
            eyebrow: "Our Septic Service Offerings",
            heading: "Complete Septic Solutions",
            items: [
                "Septic system design and planning",
                "Septic system installation",
                "Septic tank pumping and cleaning",
                "Septic system repairs and upgrades",
                "Emergency septic services",
                "Regular maintenance and inspection",
            ],
        },
        closingPhoto: "/images/services/septic.jpg",
        cta: {
            heading: "Schedule Your Septic Service",
            body:
                "Steeltooth Contracting is a leading provider of septic services in the Barrie area. Our experienced team is dedicated to delivering exceptional results for residential and commercial customers. Don't let septic issues disrupt your day-to-day life. Contact Steeltooth Contracting today for a personalized consultation and let our team of experts handle your septic system needs with precision and professionalism.",
        },
    },

    site: {
        slug: "site",
        title: "Site Services",
        hero: {
            eyebrow: "Exceptional Site Services in Barrie",
            heading: "About Steeltooth Contracting Site Services",
            img: "/images/services/site.jpg",
        },
        intro: {
            eyebrow: "Comprehensive Site Services Barrie",
            heading: "Site Services",
            body:
                "At Steeltooth Contracting, we understand the importance of expert site services in ensuring the smooth execution of your projects. Our team offers a wide range of site service solutions tailored to meet your needs, whether you're working on a residential, commercial, or industrial project. We specialize in providing sewer laterals and water main connections, waterline installation and replacement, stormwater management, firewater storage tanks, manholes, catch basins, and pump stations. With our professional site services, you can trust that your project will be completed on time and within budget.",
        },
        photo: "/images/services/site.jpg",
        quality: {
            eyebrow: "Unmatched Service Quality",
            heading: "Premier Site Services Barrie",
            body:
                "Steeltooth Contracting is the top choice for site services in the Barrie Area because of our commitment to quality, safety, and customer satisfaction. Our highly skilled team of professionals is approved by the Ontario On-site Wastewater Association, ensuring your project is in good hands. We focus on clear communication, personalized solutions, and attention to detail to deliver superior results for our clients. Choose Steeltooth Contracting for site services and experience the difference of working with a dedicated, expert team.",
        },
        offerings: {
            eyebrow: "Barrie's All-inclusive Site Services",
            heading: "Comprehensive Offerings",
            items: [
                "Sewer laterals and water main connections",
                "Waterline installation and replacement",
                "Stormwater management",
                "Firewater storage tanks",
                "Manholes and catch basins",
                "Pump stations",
            ],
        },
        closingPhoto: "/images/services/site.jpg",
        cta: {
            heading: "Contact Steeltooth Today",
            body:
                "Ready to elevate your project with expert site services in Barrie? Contact Steeltooth Contracting today, and let our experienced team guide you through every step of the process, ensuring the success of your project.",
        },
    },

    demolition: {
        slug: "demolition",
        title: "Demolition",
        hero: {
            eyebrow: "Top-Notch Demolition in Barrie",
            heading: "Demolition Contractors You Can Count On",
            img: "/images/services/demolition.jpg",
        },
        intro: {
            eyebrow: "Barrie's Demolition Experts",
            heading: "Safe Demolition",
            body:
                "Steeltooth Contracting is a trusted name in the demolition industry, providing comprehensive services for residential and commercial clients in Barrie. Our services include concrete cutting, breaking and removal, structural demolition, selective demolition, emergency demolition, and interior demolition. We also offer decommissioning services for pools, ponds, wells, and septic systems. Our highly skilled team is dedicated to safety, ensuring that every project is completed efficiently, professionally, and with minimal impact on the surrounding environment.",
        },
        photo: "/images/services/demolition.jpg",
        quality: {
            eyebrow: "Unparalleled Experience and Quality",
            heading: "Demolition Specialists in Barrie",
            body:
                "Choosing Steeltooth Contracting for your demolition needs means partnering with a team dedicated to safety and customer satisfaction. We are fully licensed, insured, and compliant with all local, state, and federal regulations. Our commitment to using the latest technology and equipment ensures that each project is completed safely and efficiently. Trust Steeltooth Contracting to deliver outstanding results for your demolition project in Barrie.",
        },
        offerings: {
            eyebrow: "Comprehensive Demolition Services Barrie",
            heading: "Full-Service Solutions",
            lede:
                "Our comprehensive services encompass complete building demolition, partial demolition and deconstruction, interior demolition and renovation, asbestos and hazardous material removal, as well as site clean-up and debris removal, ensuring a thorough and efficient process from start to finish.",
            items: [
                "Complete building demolition",
                "Partial demolition and deconstruction",
                "Interior demolition and renovation",
                "Asbestos and hazardous material removal",
                "Site clean-up and debris removal",
            ],
        },
        closingPhoto: "/images/services/demolition.jpg",
        cta: {
            heading: "Schedule Your Demolition Today",
            body:
                "Steeltooth Contracting offers reliable and professional demolition services in Barrie and the surrounding areas. We specialize in a wide range of residential and commercial demolition projects. Don't wait any longer to start your demolition project. Contact Steeltooth Contracting today for a customized consultation and let our expert team handle the complexities of your demolition needs with professionalism and care.",
        },
    },
};

export const SERVICE_ORDER = ["excavation", "septic", "site", "demolition"];
